import { Carousel } from 'bootstrap';

type CarouselInternal = Carousel & {
  touchTimeout?: ReturnType<typeof setTimeout>;
  _isSliding?: boolean;
  _clearInterval: () => void;
};

function clearCarouselTimers(instance: CarouselInternal): void {
  if (instance.touchTimeout) {
    clearTimeout(instance.touchTimeout);
    instance.touchTimeout = null;
  }
  instance._clearInterval();
}

export function disposeBootstrapCarouselSafe(root: HTMLElement, done?: () => void): void {
  const instance = Carousel.getInstance(root) as CarouselInternal | null;
  if (!instance) {
    done?.();
    return;
  }

  clearCarouselTimers(instance);
  instance.pause();

  if (!instance._isSliding) {
    instance.dispose();
    done?.();
    return;
  }

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    const current = Carousel.getInstance(root) as CarouselInternal | null;
    if (current) {
      clearCarouselTimers(current);
      current.dispose();
    }
    done?.();
  };

  root.addEventListener('slid.bs.carousel', finish, { once: true });
  window.setTimeout(finish, 700);
}

export function forceDisposeBootstrapCarousel(root: HTMLElement): void {
  const instance = Carousel.getInstance(root) as CarouselInternal | null;
  if (!instance || instance._isSliding) return;
  clearCarouselTimers(instance);
  instance.pause();
  instance.dispose();
}

export function disposeClusterPanelBootstrapCarousels(): void {
  document.querySelectorAll<HTMLElement>('.clusters-panels .carousel').forEach((root) => {
    forceDisposeBootstrapCarousel(root);
    disposeBootstrapCarouselSafe(root);
  });

  document.querySelectorAll<HTMLElement>('.clusters-panels [id$="GalleryCarousel"]').forEach((root) => {
    forceDisposeBootstrapCarousel(root);
    Carousel.getInstance(root)?.dispose();
  });
}
